import {ChangeDetectorRef, Component, NgZone, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {PatientService} from '../../Services/patient.service';
import {ClientService} from '../../Services/client.service';
import {AuthService} from '../../auth/AuthService';
import {Router} from '@angular/router';
import {first} from 'rxjs/operators';
import swal from 'sweetalert2';
import {Sort} from '@angular/material/sort';
import {ProviderService} from '../../Services/provider.service';
import Swal from 'sweetalert2';
import {StaffService} from '../../Services/staff.service';
import {Subject} from "rxjs";

@Component({
    selector: 'pm-provider-registration',
    templateUrl: './provider-registration.component.html',
    styleUrls: ['./provider-registration.component.css']
})

export class ProviderRegistrationComponent implements OnInit {
    selectedTable: string = 'provider';
    tableData: any = [];
    tableStaffData: any = [];
    phoneType: any = [
        {value: 'Mobile', viewValue: 'Mobile'},
        {value: 'Work', viewValue: 'Work'},
        {value: 'Home', viewValue: 'Home'},
    ];
    searchText: any;
    private clientSub: any;
    private subject: Subject<string> = new Subject();

    constructor(private fb: FormBuilder,
                private providerServices: ProviderService,
                private staffServices: StaffService,
                public authService: AuthService,
                private router: Router,
                private cdr: ChangeDetectorRef,
                private ngZone: NgZone) {
    }

    ngOnInit(): void {
        this._fetchData(1);
        this._fetchStaffData(1);
        this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
          if (clientId) {
            this._fetchData(1);
            this._fetchStaffData(1);
          }
        });
    }

    ngOnDestroy(): void {
      this.clientSub?.unsubscribe();
    }

    // Fetch data based on the selected table type (provider or staff)
    fetchDataBasedOnSelection() {
        // console.log('Selected Table:', this.selectedTable);
        if (this.selectedTable === 'provider') {
            this._fetchData(); // Call method to fetch provider data
        } else if (this.selectedTable === 'staff') {
            this._fetchStaffData(); // Call method to fetch staff data
        }
    }

    // Get Provider data
    _fetchData(type?: any) {
    const params: any = {
      clientId: this.authService.clientId,
      active: true
    };

    if (type === 3) {
      params.active = false;
    } else {
      params.active = true;
    }

    this.providerServices.getAllProviders(params).pipe(first()).subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          if (response && response.length > 0) {
            this.tableData = response;
          } else {
            this.tableData = [];
            swal.fire({
              title: 'Error!',
              icon: 'error',
              text: response?.message || 'No data found',
              showConfirmButton: false,
              timer: 5000
            });
          }

          setTimeout(() => {
            this.cdr.detectChanges();
          }, 0);
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.tableData = [];
          this.cdr.detectChanges();

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text: error?.error?.message || '',
            showConfirmButton: false,
            timer: 5000
          });
        });
      }
    );
  }

    // Get Staff Data
    _fetchStaffData(type?: any) {
    const params: any = {
      clientId: this.authService.clientId,
      active: true
    };

    if (type === 3) {
      params.active = false;
    } else {
      params.active = true;
    }

    this.staffServices.getAllStaffs(params).pipe(first()).subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          if (response && response.length > 0) {
            this.tableStaffData = response;
          } else {
            this.tableStaffData = [];
          }

          setTimeout(() => {
            this.cdr.detectChanges();
          }, 0);
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.tableStaffData = [];
          this.cdr.detectChanges();
        });
      }
    );
  }

    // Delete record
    deleteEntry(providerId: any) {
        let reqData = {
            providerId: providerId
        };
        Swal.fire({
            title: 'Are you sure?',
            text: 'You want to delete this record ?',
            icon: 'warning',
            iconColor: 'red',
            showCancelButton: true,
            confirmButtonText: 'Yes !'
        }).then((result) => {
            if (result.isConfirmed) {
                this.providerServices.deleteProvider(reqData).pipe(first()).subscribe(
                    (response: any) => {
                        if (response) {
                            this._fetchData(1);
                            swal.fire({
                                icon: 'success',
                                text: `Provider Deleted successfully.`,
                                showConfirmButton: false,
                                timer: 3000,
                            });
                        } else {
                            swal.fire({
                                title: 'Error!',
                                icon: 'error',
                                text: 'Something went wrong!',
                                showConfirmButton: false,
                                timer: 2000
                            });
                        }
                    },
                    (error) => {
                        swal.fire({
                            title: 'Error!',
                            icon: 'error',
                            text: 'Failed to communicate with the server!',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    });
            }
        });
    }

    // Update entry
    /*    updateEntry = (clientId: any) => {
            this.router.navigate(['client/details/' + clientId]).then();
        }*/
    // Search
    onKeyUp(searchTextValue: any): void {
      this.subject.next(searchTextValue);
    }

    handleKeyUp(event: KeyboardEvent) {
      const value = (event.target as HTMLInputElement).value;

      // Trigger search on Enter
      if (event.key === 'Enter') {
        this.onKeyUp(this.searchText);
        return;
      }

      // Existing debounce logic
      this.subject.next(value);
    }
    clearSearch(input: HTMLInputElement) {
      input.value = '';
      /*this.searchString = '';*/
      /*this.pagination.currentPage = 0;
      this.pagination.page = 1;*/
      this._fetchData(1);
      this._fetchStaffData(1);
    }
    // Sort form frontend logic
    sortProviderData(sort: Sort) {
        const data = this.tableData.slice();
        if (!sort.active || sort.direction === '') {
            this.tableData = data;
            return;
        }

        this.tableData = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'firstName':
                    return compare(a.firstName, b.firstName, isAsc);
                case 'clientName':
                    return compare(a.clientName, b.clientName, isAsc);
                case 'officeName':
                    return compare(a.officeName, b.officeName, isAsc);
                case 'staffType':
                    return compare(a.staffType, b.staffType, isAsc);
                case 'number':
                    return compare(a.number, b.number, isAsc);
                case 'email':
                    return compare(a.email, b.email, isAsc);
                case 'type':
                    return compare(a.type, b.type, isAsc);
                case 'degree':
                    return compare(a.degree, b.degree, isAsc);
                case 'salutation':
                    return compare(a.salutation, b.salutation, isAsc);
                case 'taxId':
                    return compare(a.taxId, b.taxId, isAsc);
                case 'license':
                    return compare(a.license, b.license, isAsc);
                case 'npi':
                    return compare(a.npi, b.npi, isAsc);
                case 'firstLine':
                    return compare(a.firstLine, b.firstLine, isAsc);
                case 'active':
                    return compare(a.active, b.active, isAsc);
                default:
                    return 0;
            }

        });
    }

    sortStaffData(sort: Sort) {
        const data = this.tableStaffData.slice();
        if (!sort.active || sort.direction === '') {
            this.tableStaffData = data;
            return;
        }

        this.tableStaffData = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'firstName':
                    return compare(a.firstName, b.firstName, isAsc);
                case 'name':
                    return compare(a.name, b.name, isAsc);
                case 'staffType':
                    return compare(a.staffType, b.staffType, isAsc);
                case 'number':
                    return compare(a.number, b.number, isAsc);
                case 'email':
                    return compare(a.email, b.email, isAsc);
                case 'salutation':
                    return compare(a.salutation, b.salutation, isAsc);
                case 'firstLine':
                    return compare(a.firstLine, b.firstLine, isAsc);
                case 'active':
                    return compare(a.active, b.active, isAsc);
                default:
                    return 0;
            }
        });
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
